module.exports = __webpack_public_path__ + "static/media/feast_at_home.53898ec8.jpeg";